import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from 'app/components/ui/toast';
import { useToast } from 'app/components/ui/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex gap-1.5 sm:gap-2 items-start">
              {variant === 'error' ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 size-4 sm:size-[1.125rem] lg:size-5 mt-1" viewBox="0 0 20 20" fill="none">
                  <path d="M10 0.75C15.1086 0.75 19.25 4.89137 19.25 10C19.25 15.1086 15.1086 19.25 10 19.25C4.89137 19.25 0.75 15.1086 0.75 10C0.75 4.89137 4.89137 0.75 10 0.75Z" stroke="#FB3836" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13 7L7 13" stroke="#FB3836" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 7L13 13" stroke="#FB3836" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ) : variant === 'success' ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 size-4 sm:size-[1.125rem] lg:size-5 mt-0.5" viewBox="0 0 22 22" fill="none">
                  <path d="M21 10.0857V11.0057C20.9988 13.1621 20.3005 15.2604 19.0093 16.9875C17.7182 18.7147 15.9033 19.9782 13.8354 20.5896C11.7674 21.201 9.55726 21.1276 7.53447 20.3803C5.51168 19.633 3.78465 18.2518 2.61096 16.4428C1.43727 14.6338 0.879791 12.4938 1.02168 10.342C1.16356 8.19029 1.99721 6.14205 3.39828 4.5028C4.79935 2.86354 6.69279 1.72111 8.79619 1.24587C10.8996 0.770634 13.1003 0.988061 15.07 1.86572" stroke="#48B16E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M21 3.00391L11 13.0139L8 10.0139" stroke="#48B16E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ) : variant === 'failure' ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 size-4 sm:size-[1.125rem] lg:size-5 mt-1" viewBox="0 0 20 20" fill="none">
                  <path d="M10 0.75C15.1086 0.75 19.25 4.89137 19.25 10C19.25 15.1086 15.1086 19.25 10 19.25C4.89137 19.25 0.75 15.1086 0.75 10C0.75 4.89137 4.89137 0.75 10 0.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13 7L7 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 7L13 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ) : null}
              <div className="grid">
                {title && (
                  <ToastTitle>{title}</ToastTitle>
                )}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose variant={toasts[0]?.variant as 'default' | 'success' | 'error' | 'failure' | undefined} />
          </Toast>
        );
      })}
      <ToastViewport variant={toasts[0]?.variant as 'default' | 'success' | 'error' | 'failure' | undefined} />
    </ToastProvider>
  );
}
